module.exports = __webpack_public_path__ + "static/media/Concrete Dark.c97ed7a9.jpg";